/**
 * Application Version Information
 * 
 * This file is auto-generated by scripts/generate-version.js
 * DO NOT EDIT MANUALLY
 * 
 * To update version:
 * - Edit version.json in the project root
 * - Run npm run generate-version or npm run build
 */

export const APP_VERSION = '1.1.260313-2201';
export const VERSION_MAJOR = 1;
export const VERSION_MINOR = 1;
export const BUILD_NUMBER = '260313-2201';
export const BUILD_DATE = '2026-03-13T22:01:13.915Z';
export const VERSION_DESCRIPTION = 'Add versioning info';

export const getVersionInfo = () => ({
  version: APP_VERSION,
  major: VERSION_MAJOR,
  minor: VERSION_MINOR,
  build: BUILD_NUMBER,
  buildDate: BUILD_DATE,
  description: VERSION_DESCRIPTION,
});
